// @flow
import * as React from "react";

import AuthService from "services/auth";

const Error404 = React.lazy(() => import("views/screens/Error404"));
const Error503 = React.lazy(() => import("views/screens/Error503"));
const ApplicationError = React.lazy(() => import("views/screens/ApplicationError"));

const DangerAlert = React.lazy(() => import("views/UI/alerts/DangerAlert"));

function ErrorHandler({ error, children }): React.Node {
  if (error) {
    if (typeof error.response === "undefined") {
      return <ApplicationError />;
    }

    switch (error.response.status) {
      case 400:
      case 409:
        return (
          <React.Fragment>
            <DangerAlert message={error.response.data.cause} />
            {children}
          </React.Fragment>
        );
      case 401:
        AuthService.logout();

        window.location.replace("/login");

        return null;
      case 403:
      case 404:
        return <Error404 />;
      default:
        return <Error503 />;
    }
  } else {
    return children;
  }
}

function withErrorHandler(Component) {
  class WithErrorHandler extends React.PureComponent {
    state = {
      error: null,
    };

    handleError = (error) => {
      this.setState({ error });
    };

    render(): React.Node {
      return (
        <React.Suspense fallback={null}>
          <ErrorHandler error={this.state.error}>
            <Component {...this.props} onError={this.handleError} />
          </ErrorHandler>
        </React.Suspense>
      );
    }
  }

  return WithErrorHandler;
}

export default withErrorHandler;
